import { supabase } from './supabase';

export type ServiceEntry = {
  id: string;
  user_id: string;
  mileage: number;
  date: string;
  price: number;
  notes: string;
  type: string;
  inserted_at: string;
};

// Fetch entries with optional search and filter
export async function fetchServiceEntries({ search = '', type = '' }: { search?: string; type?: string }) {
  let query = supabase
    .from('service_book')
    .select('*')
    .order('date', { ascending: false });

  if (type && type !== 'all') {
    query = query.eq('type', type);
  }
  if (search) {
    query = query.or(`notes.ilike.%${search}%,type.ilike.%${search}%`);
  }

  const { data, error } = await query;
  if (error) throw error;
  return data as ServiceEntry[];
}

export async function addServiceEntry(entry: Omit<ServiceEntry, 'id' | 'inserted_at'>) {
  const { data, error } = await supabase
    .from('service_book')
    .insert([{ ...entry }])
    .select()
    .single();
  if (error) throw error;
  return data as ServiceEntry;
}

export async function updateServiceEntry(id: string, entry: Partial<Omit<ServiceEntry, 'id' | 'user_id' | 'inserted_at'>>) {
  const { data, error } = await supabase
    .from('service_book')
    .update(entry)
    .eq('id', id)
    .select()
    .single();
  if (error) throw error;
  return data as ServiceEntry;
}

export async function deleteServiceEntry(id: string) {
  const { error } = await supabase
    .from('service_book')
    .delete()
    .eq('id', id);
  if (error) throw error;
  return true;
} 